import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@cmps/ng-bootstrap';
import { VerticalOptions } from '@cmps/ng-chart';
import { TranslateService } from '@ngx-translate/core';

import { CmpsPercentPipe } from '../common/number.pipe';
import { WidgetConfiguration } from '../widget/config.widget.model';
import { ModalWidgetComponent } from '../widget/modal.widget.component';
import { CMPS_WIDGET_CONFIG } from '../widget/widget.metadata';

import { TranslationKeyMap } from './legacy-widget.i18n';
import { LegacyWidgetService } from './legacy-widget.service';
import { PillarPerformanceWidgetComponent } from './pillar-performance.widget.component';
import { TeamDistributionByPillar } from './team-distribution-by-pillar.widget.model';

@Component({
    selector: 'cmps-widget-team-distribution-by-pillar',
    templateUrl: './team-distribution-by-pillar.widget.component.html',
})
export class TeamDistributionByPillarWidgetComponent
    implements OnInit, OnDestroy
{
    i18n = TranslationKeyMap;
    hasPendingData: boolean;
    options: VerticalOptions;
    data: TeamDistributionByPillar;
    private _modal: NgbModalRef;

    // TODO revise
    private _showGoToDashboardButton: boolean;
    private _kpiIds: number[];

    constructor(
        private readonly _modalService: NgbModal,
        private readonly _translateService: TranslateService,
        @Inject(CMPS_WIDGET_CONFIG) public config: WidgetConfiguration,
        private readonly _service: LegacyWidgetService,
        private readonly _percentPipe: CmpsPercentPipe,
    ) {
        this._evalAttributes();
    }

    ngOnInit(): void {
        this.options = {
            rect: { width: '100%', height: 250, top: 10 },
            stacked: true,
            showLegend: true,
            yDomain: () => [0, 100],
            yAxis: (yAxis) =>
                yAxis
                    .ticks(100 / 20)
                    .tickFormat((d) =>
                        this._percentPipe.transform(d / 100, '1.0-0'),
                    ),
        };

        this.hasPendingData = true;
        this._service.teamDistributionByPillar().subscribe(
            (data) => {
                data.d3.data[0].key = this._translateService.instant(
                    TranslationKeyMap._794_UNFAVOURABLE,
                );
                data.d3.data[1].key = this._translateService.instant(
                    TranslationKeyMap._795_CLOSE_TO_TARGET,
                );
                data.d3.data[2].key = this._translateService.instant(
                    TranslationKeyMap._796_FAVOURABLE,
                );
                this.data = data;
            },
            // eslint-disable-next-line n/handle-callback-err, no-return-assign
            (error) => (this.hasPendingData = false),
            // eslint-disable-next-line no-return-assign
            () => (this.hasPendingData = false),
        );
    }

    ngOnDestroy(): void {
        if (this._modal) {
            this._modal.close();
        }
    }

    // TODO revise
    private _evalAttributes(): void {
        this._kpiIds = [];
        this.config.attributes
            .filter((attr) => attr.name)
            .map((attr) => {
                attr.name = attr.name.toLowerCase();
                return attr;
            })
            .forEach((attr) => {
                // if (attr.name === 'displayallpillars')
                // if (attr.name === 'displayvariance')
                // if (attr.name === 'format')
                // if (attr.name === 'includeqtr')
                // if (attr.name === 'includesg')
                // if (attr.name === 'showdateselector')
                if (attr.name === 'showgotodashboardbutton')
                    this._showGoToDashboardButton =
                        attr.value !== '0' &&
                        attr.value.toLowerCase() !== 'false';
                // if (attr.name === 'timeframe')
                if (attr.name.startsWith('kpiid')) {
                    if (attr.value == null || attr.value.length === 0) return;
                    this._kpiIds.push(parseInt(attr.value));
                }
            });
    }

    showDetails(): void {
        this._modal = this._modalService.open(ModalWidgetComponent, {
            size: 'lg',
        });
        this._modal.componentInstance.config = {
            header: this.config.title,
            component: PillarPerformanceWidgetComponent,
            options: {
                hasDetails: this._showGoToDashboardButton,
                definitionId: this.config.definitionId,
                pillarIds: this._kpiIds,
            },
        };
        // eslint-disable-next-line no-return-assign
        this._modal.result.then(
            (result) => (this._modal = null),
            (reason) => (this._modal = null),
        );
    }
}
